<template>
  <div class="content-box">
    <div class="form-box">
      <div v-if="usetState === -1" style="padding: 10px 0;color: #e90000;">您的申请未通过，原因：{{reason}}</div>
      <p class="tips">温馨提示：标注*号项为必填项</p>
      <div class="form-item">
        <span>姓名<b>*</b></span>
        <van-field class="form-input" v-model="name" placeholder="请输入真实姓名"/>
      </div>
      <div class="form-item">
        <span>性别<b>*</b></span>
        <van-radio-group class="form-input" v-model="sex" direction="horizontal">
          <van-radio name="1" checked-color="#2b8ee3">男</van-radio>
          <van-radio name="0" checked-color="#2b8ee3">女</van-radio>
        </van-radio-group>
      </div>
      <div class="form-item" @click="modeShow=true">
        <span>出生年月<b>*</b></span>
        <van-field class="form-input" v-model="date"  placeholder="请选择出生年月" readonly/>
        <i class="iconfont iconzhouqi"></i>
      </div>
      <div class="form-item" @click="faceShow=true">
        <span>政治面貌<b>*</b></span>
        <van-field class="form-input" v-model="face" placeholder="请选择政治面貌" readonly/>
        <i class="iconfont iconxiayibu"></i>
      </div>
      <div class="form-item">
        <span>民族<b>*</b></span>
        <van-field class="form-input" v-model="nation" placeholder="请输入民族"/>
      </div>
      <div class="form-item">
        <span>是否院士<b>*</b></span>
        <van-radio-group class="form-input" v-model="ys" direction="horizontal">
          <van-radio name="1" checked-color="#2b8ee3">是</van-radio>
          <van-radio name="0" checked-color="#2b8ee3">否</van-radio>
        </van-radio-group>
      </div>
      <!--<div class="form-item" >-->
        <!--<span>院士类别<b>*</b></span>-->
        <!--<van-radio-group class="form-input" v-model="yslb" direction="horizontal">-->
          <!--<van-radio name="1" checked-color="#2b8ee3">中国科学院院士</van-radio>-->
          <!--<van-radio name="0" checked-color="#2b8ee3">中国工程院院士</van-radio>-->
        <!--</van-radio-group>-->
      <!--</div>-->
      <div class="form-item" v-show="ys === '1'"  @click="yslbShow=true">
        <span>院士类别<b>*</b></span>
        <van-field class="form-input" v-model="yslb" placeholder="请选择院士类别" readonly/>
        <i class="iconfont iconxiayibu"></i>
      </div>
      <div class="form-item" @click="educationShow=true">
        <span>学历<b>*</b></span>
        <van-field class="form-input" v-model="education" placeholder="请选择学历" readonly/>
        <i class="iconfont iconxiayibu"></i>
      </div>
      <div class="form-item">
        <span>专业<b>*</b></span>
        <van-field class="form-input" v-model="major" placeholder="请输入专业"/>
      </div>
      <div class="form-item">
        <span>职称<b>*</b></span>
        <van-field class="form-input" v-model="title" placeholder="请输入职称"/>
      </div>
      <div class="form-item">
        <span>身份证号<b>*</b></span>
        <van-field class="form-input" v-model="idNumber" placeholder="请输入身份证号"/>
      </div>
      <div class="form-item">
        <span>联系电话<b>*</b></span>
        <van-field class="form-input" type="tel" v-model="tel" placeholder="请输入联系电话"/>
      </div>
      <div class="form-item" @click="addressShow=true">
        <span>所属辖区<b>*</b></span>
        <van-field class="form-input" v-model="addressCn" placeholder="请选择所属辖区" readonly/>
        <i class="iconfont iconxiayibu"></i>
      </div>
      <div class="form-item">
        <span>详细地址<b>*</b></span>
        <van-field class="form-input" v-model="detailAddress" placeholder="请输入详细地址"/>
      </div>
      <div class="form-item">
        <span>电子邮箱<b>*</b></span>
        <van-field class="form-input" v-model="email" placeholder="请输入电子邮箱"/>
      </div>
      <div class="form-item">
        <span>工作单位(原)<b>*</b></span>
        <van-field class="form-input" v-model="company" placeholder="请输入工作单位(原)"/>
      </div>
      <div class="form-item">
        <span>职务<b>*</b></span>
        <van-field class="form-input" v-model="post" placeholder="请输入职务"/>
      </div>
      <div class="form-item">
        <span style="width: 100%">担任其他社会职务<b>*</b></span>
        <van-field
          class="form-input active"
          v-model="otherPost"
          rows="1"
          autosize
          type="textarea"
          placeholder="如未担任其他社会职务，请填写“无”"
        />
      </div>
    </div>
    <div class="form-box">
      <div class="form-item">
        <span>推荐人1姓名</span>
        <van-field class="form-input" v-model="t1name" placeholder="推荐人1姓名"/>
      </div>
      <div class="form-item">
        <span>推荐人2姓名</span>
        <van-field class="form-input" v-model="t2name" placeholder="推荐人2姓名"/>
      </div>
      <div class="form-item">
        <span>推荐单位名称</span>
        <van-field class="form-input" v-model="t3name" placeholder="推荐单位名称"/>
      </div>
      <div class="shengming">
        <h3>入会声明</h3>
        <p>本人自愿加入北京老科学技术工作者总会，遵守总会章程和各项规定，自觉维护总会利益，履行会员义务，积极 参加总会的各项活动和承接总会分配的任务。</p>
        <p> 特此声明</p>
        <div class="check-box">
          <van-checkbox v-model="checked" shape="square" checked-color="#2b8ee3">我同意“入会声明” 及<a href="/content/act" style="color: #2b8ee3;">总会章程</a></van-checkbox>
        </div>
      </div>
      <p class="tips">温馨提示：</p>
      <p class="tips">
        申请可附学习工作简历及主要成果、身份证、学历、职称以及其他奖项证明材料，上传附件请登录电脑端：http://bjlkz.emof.cn/ 操作。
      </p>
    </div>

    <div class="clear-box"></div>
    <van-button type="info" class="submit-btn" @click="submitForm">提交申请</van-button>

    <van-popup v-model="modeShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="chioseStart"
        @cancel="closeCancel"
      />
    </van-popup>
    <van-popup v-model="faceShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="faceConfirm"
        @cancel="faceCancel"
      />
    </van-popup>
    <van-popup v-model="educationShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="educationArr"
        @confirm="eduConfirm"
        @cancel="eduCancel"
      />
    </van-popup>
    <van-popup v-model="yslbShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="yslbArr"
        @confirm="yslbConfirm"
        @cancel="yslbCancel"
      />
    </van-popup>
    <van-popup v-model="addressShow" position="bottom">
      <van-area :area-list="areaList" @cancel="addressCancel" @confirm="addressConfirm"/>
    </van-popup>
  </div>
</template>

<script>
  import AreaList from '../../tools/area';

  export default {
    name: "Info",
    data() {
      return {
        usetState: '',       //  审核状态 0 审核中  -1 退回  1 通过
        reason: '',          //  未审核通过的原因
        name: '',          //  姓名
        sex: '',           //  性别
        ys:'',      //  是否院士
        date: '',          //  出生日期
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(2020, 12, 31),
        face: '',          //  政治面貌
        faceId: '',         //  政治面貌Id
        nation: '',        //  民族
        education: '',     //  学历
        educationId: '',     //  学历id\
        yslbId:'',     // 院士类别ID
        yslb:'',      //  院士类别
        major: '',         //  专业
        title: '',         //  职称
        idNumber: '',      //  身份证号
        tel: '',           //  联系电话
        address: '',       //  地址code
        addressCn: '',      //  地址
        detailAddress: '', //  详细地址
        email: '',         //  邮箱
        company: '',       //  单位
        post: '',          //  职务
        otherPost: '',     //  其它职务
        t1name: '',
        t2name: '',
        t3name: '',
        checked: false,      // 同意入会协议
        modeShow: false,     //  出生日期显示
        currentDate: new Date(1950, 0, 1),
        faceShow: false,     //  政治面貌显示
        columnsAll: [],      //  政治面貌全部数据
        columns: [],
        educationShow: false,  //  学历
        yslbShow: false,  //  院士类别
        educationAll: [],
        yslbAll:[{
          value:'中国科学院院士',
          id: 0
        },{
          value:'中国工程院院士',
          id: 1
          }
        ],
        educationArr: [],
        yslbArr:['中国科学院院士','中国工程院院士'],
        addressShow: false,  //  地址显示
        areaList: AreaList, //  地址选项
        timer:''
      }
    },
    created() {
      this.init()
      // if (this.$store.state.user.checkStatus == -1) {
      //   this.getFrom()
      // }
      // if (this.$store.state.user.checkStatus == 0){
      //   this.$router.push('/content/auditStatus')
      // }
      this.usetState = Number(this.$store.state.user.checkStatus)
    },
    methods: {
      /*
     * 时时保存信息
     * */
      editForm(){
        this.$api.apiContent.editUser({
          token: this.$store.state.user.token,
          nickname: this.name,
          sex: this.sex?this.sex:'',
          naFlag:this.ys?this.ys:'',
          na_name:this.yslb?this.yslb:'',
          birthdayText: this.date,
          politic: this.faceId?this.faceId.join(','):'',
          nation: this.nation,
          education: this.educationId,
          major: this.major,
          title: this.title,
          idcard: this.idNumber,
          phone: this.tel,
          addrCode: this.address?this.address:'',
          addrText: this.addressCn?this.addressCn.split(' ').join(','):'',
          addrDetail: this.detailAddress,
          email: this.email,
          workUnit: this.company,
          duty: this.post,
          dutyOther: this.otherPost,
          ref1: this.t1name,
          ref2: this.t2name,
          refUnit: this.t3name
        }).then(() => {

        }).catch(() => {
        })
      },
      /*
     * 提交用户信息
     * */
      submitForm() {
        if(!this.name){
          this.$toast('请填写姓名')
          return
        }
        if(this.sex == ''){
          this.$toast('请选择性别')
          return
        }
        if(this.ys == ''){
          this.$toast('请选择是否院士')
          return
        }
        if(this.ys == '1'){
          if(this.yslb == ''){
            this.$toast('请选择院士类别')
            return
          }
        }
        if(!this.date){
          this.$toast('请选择出生年月')
          return
        }
        if(!this.faceId){
          this.$toast('请选择政治面貌')
          return
        }
        if(!this.nation){
          this.$toast('请填写民族')
          return
        }
        if(this.educationId == '' ){
          this.$toast('请选择学历')
          return
        }
        if(!this.major ){
          this.$toast('请填写专业')
          return
        }
        if(!this.title){
          this.$toast('请填写职称')
          return
        }
        if(!this.idNumber){
          this.$toast('请填写身份证号')
          return
        }
        if(!this.tel){
          this.$toast('请填写联系方式')
          return
        }
        if(!this.address){
          this.$toast('请填写所属辖区')
          return
        }
        if(!this.detailAddress){
          this.$toast('请填写详细地址')
          return
        }
        if(!this.email){
          this.$toast('请填写邮箱')
          return
        }
        if(!this.company){
          this.$toast('请填写工作单位')
          return
        }
        if(!this.post){
          this.$toast('请填写职务')
          return
        }
        if(!this.otherPost){
          this.$toast('请填写担任其他社会职务')
          return
        }
        if(!this.checked){
          this.$toast('请点击同意入会声明及《总会章程》')
          return;
        }
        this.$dialog.confirm({
          title: '温馨提示',
          message: '请确认信息，提交后不能修改。',
        })
          .then(() => {
            this.$api.apiContent.submitUser({
              token: this.$store.state.user.token,
              nickname: this.name,
              sex: this.sex,
              naFlag: this.ys,
              naName: this.yslbId,
              birthdayText: this.date,
              politic: this.faceId.join(','),
              nation: this.nation,
              education: this.educationId,
              major: this.major,
              title: this.title,
              idcard: this.idNumber,
              phone: this.tel,
              addrCode: this.address,
              addrText: this.addressCn.split(' ').join(','),
              addrDetail: this.detailAddress,
              email: this.email,
              workUnit: this.company,
              duty: this.post,
              dutyOther: this.otherPost,
              ref1: this.t1name,
              ref2: this.t2name,
              refUnit: this.t3name
            }).then(() => {
              this.$toast('提交成功')
              this.$store.state.user.checkStatus = 0
              this.$router.push('/content/auditStatus')

            }).catch(e => {
              this.$toast(e.msg)
            })
          })
          .catch(() => {
            // on cancel
          });



      },


      /*
      * 获取用户信息
      * */
      getFrom() {
        this.$api.apiContent.getUser({
          token: this.$store.state.user.token
        }).then(res => {
          console.log(res)
          this.reason = res.row.reason
          this.name = res.row.nickname          //  姓名
          this.sex = res.row.sex?String(res.row.sex):''            //  性别
          this.ys = res.row.naFlag?String(res.row.naFlag):''            //  是否院士
          this.yslbId = res.row.naName !== '' ? Number(res.row.naName)  : ''            //  是否院士
          this.date = res.row.birthdayText?res.row.birthdayText:''          //  出生日前
          this.faceId = res.row.politic?res.row.politic.split(','):''          //  政治面貌
          this.nation = res.row.nation        //  民族
          this.educationId = res.row.education ? Number(res.row.education):''     //  学历id
          this.major = res.row.major         //  专业
          this.title = res.row.title         //  职称
          this.idNumber = res.row.idcard      //身份证号
          this.tel = res.row.phone          //联系电话
          this.address = res.row.addrCode       //地址
          this.addressCn = res.row.addrText?res.row.addrText.split(',').join(' '):''       //地址
          this.detailAddress = res.row.addrDetail //详细地址
          this.email = res.row.email         //邮箱
          this.company = res.row.workUnit       //单位
          this.post = res.row.duty          //职务
          this.otherPost = res.row.dutyOther     //其它职务
          this.t1name = res.row.ref1
          this.t2name = res.row.ref2
          this.t3name = res.row.refUnit

          this.educationAll.map(item => {
            if (Number(item.id) === this.educationId) {
              this.education = item.text
            }
          })
          this.yslbAll.map(item => {
            if (Number(item.id) === this.yslbId) {
              this.yslb = item.value
            }
          })

          let arr = []
          this.columnsAll.map(item => {
            if (Number(item.id) === Number(this.faceId[0])) {
              arr.push(item.text)
              this.face = arr.join(' ')
            }
            item.child.map(items => {
              if (Number(items.id) === Number(this.faceId[1])) {
                arr.push(items.text)
                this.face = arr.join(' ')
              }
            })
          })
          this.timer = setInterval(()=>{
            this.editForm()
          },2000)
        }).catch(e => {
          console.log(e)
        })
      },
      /*
      * 获取学历和政治面貌
      * */
      init() {
        this.$api.apiContent.getMianmao({
          token: this.$store.state.user.token
        }).then(res => {
          this.columnsAll = res.row
          res.row.map(item => {
            this.columns.push({
              text: item.text,
              children: item.child.length === 0 ? [{text: ''}] : item.child
            })
          })
          this.$api.apiContent.getEdu({
            token: this.$store.state.user.token
          }).then(res => {
            this.educationAll = res.row
            res.row.map(item => {
              this.educationArr.push(item.text)
            })
            this.getFrom()
          }).catch(e => {
            console.log(e)
          })
        }).catch(e => {
          console.log(e)
        })

      }
      ,
      //  地区选择
      addressConfirm(e) {
        this.addressShow = false
        this.address = e[0].code + ',' + e[1].code + ',' + e[2].code
        this.addressCn = e[0].name + ' ' + e[1].name + ' ' + e[2].name
      }
      ,
      addressCancel() {
        this.addressShow = false
      }
      ,
      //  学历
      eduConfirm(value, index) {
        this.education = value
        this.educationId = this.educationAll[index].id
        this.educationShow = false
      }
      ,
      eduCancel() {
        this.educationShow = false
      }
      ,

      //  院士类别
      yslbConfirm(value, index) {
        this.yslb = value
        this.yslbId = this.yslbAll[index].id
        this.yslbShow = false
      }
      ,
      yslbCancel() {
        this.yslbShow = false
      }
      ,

      //  政治面貌选择
      faceConfirm(value, index) {
        this.face = value[0] + ' ' + value[1]

        console.log(index[0])
        console.log(this.columnsAll[index[0]].id)

        this.faceId = []
        this.faceId.push(this.columnsAll[index[0]].id)
        if (this.columnsAll[index[0]].child.length > 0) {
          this.faceId.push(this.columnsAll[index[0]].child[index[1]].id)
        }
        this.faceShow = false
      }
      ,
      faceCancel() {
        this.faceShow = false
      }
      ,

      //  时间选择
      closeCancel() {
        this.modeShow = false
      }
      ,
      chioseStart(value) {
        this.modeShow = false
        this.date = this.$tools.ZHDate(value,9)
        // this.maxDate2 = new Date(this.start_time)
      }
    },
    destroyed(){
      clearInterval(this.timer)
      this.timer = null
    },
  }
</script>

<style scoped lang="scss">
  .content-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background: #EEEFF2;
    overflow-y: scroll;

    .submit-btn {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 50px;
      padding: 0;
      text-align: center;
      line-height: 50px;
      color: #fff;
      background-color: #2b8ee3;

      span {
        font-size: 18px;
      }
    }

    .clear-box {
      width: 100%;
      height: 70px;
    }

    .form-box {
      margin: 15px;
      padding: 10px;
      background: #fff;
      border-radius: 5px;

      .tips {
        font-size: 16px;
        line-height: 24px;
        color: #ff4747;
      }

      .form-item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        min-height: 50px;
        border-bottom: 1px solid #EEEFF2;

        span {
          width: 110px;
          line-height: 50px;
          margin-right: 10px;

          b {
            color: #ff4747;
          }
        }

        .form-input {
          flex: 1;
          padding: 0;

          &.active {
            flex: none;
            width: 100%;
          }
        }

        i {
          font-size: 18px;
          color: #999;
        }
      }

      .shengming {
        padding: 20px 0;

        h3 {
          line-height: 150%;
          font-size: 16px;
        }

        p {
          line-height: 150%;
          font-size: 16px;
          text-indent: 24px;
        }
      }

      .check-box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 20px;
        margin-top: 20px;
      }
    }
  }
</style>
